import React, { useContext, useState } from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'
import {IoMdArrowDropdown} from 'react-icons/io'
import {IoChevronBackOutline} from  'react-icons/io5'
import {BiCheck} from  'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { AiOutlinePlusCircle, AiFillFolder, AiFillFile, AiFillCheckCircle, AiOutlinePlus, AiOutlineCloseCircle, AiOutlineUpload} from 'react-icons/ai'
import {FiCornerRightDown} from 'react-icons/fi'
import { Service } from '../../services/api'
import { AlertContext } from '../../context/alert_context'

export default function AgregarTag({...props}) {
    const {notify} = useContext(AlertContext);
    const [state, setState] = useState({
        step:0,
        tag:''
    })

    const onAddTag = async () => {
        if(state.tag === ''){
            return;
        }

        let body = {
            name:state.tag
        }
        let add_tag = await Service('POST','Tag',body);

        if(add_tag.status === 201){
            notify({title:'Agregar Etiqueta', message:'¡Listo!', type:'success'})
        }else{
            notify({title:'Agregar Etiqueta', message:'Error!  Algo salio mal, intenta de nuevo más tarde.', type:'error'})
        }
        props.onCancel();
}
  return (
    <div className='overlay d-flex justify-content-center align-items-center'>
        <Renderif isTrue={state.step === 0}>
            <div className='bv-modal shadow overflow-auto hide-scroll'>

                <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                    <div className='f-14 bold text-gray'>Agregar Tag</div>
                    <div className='col'></div>
                    <div className='bv-icon bv-icon--mid cursor-pointer' onClick={()=>{
                        props.onCancel()
                    }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                </div>

                <div className='px-4 pb-4'>
                    
                   
                    <input value={state.value} onChange={(evt)=>{
                        setState({...state, tag:evt.currentTarget.value})
                    }} className='input--light'></input>
        

                </div>

                <div className='d-flex b-top p-4'>
                    <div className='col'></div>
                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer'  onClick={()=>{
                            props.onCancel();
                    }}>Cancelar</div>
                    <div className='bv-pill bv-pill--primary cursor-pointer' onClick={()=>{
                            onAddTag()
                    }}>Continuar</div>
                </div>

            </div>
        </Renderif>
    
    </div>
  )
}
